export default __webpack_public_path__ + "images/aad1af46337e769ca678f0ef759d33ce-woman2.jpg";